export interface FitzpatrickSkinType {
  type: "I" | "II" | "III" | "IV" | "V" | "VI";
  description: string;
}

export const getFitzpatrickSkinType = (score: number): FitzpatrickSkinType => {
  if (score <= 7)
    return { type: "I", description: "Very fair, always burns, never tans" };
  if (score <= 16)
    return { type: "II", description: "Fair, usually burns, tans minimally" };
  if (score <= 25)
    return {
      type: "III",
      description: "Medium, sometimes burns, tans gradually",
    };
  if (score <= 30)
    return { type: "IV", description: "Olive, rarely burns, tans easily" };
  if (score <= 35)
    return { type: "V", description: "Brown, very rarely burns, tans deeply" };
  return { type: "VI", description: "Black, never burns, deeply pigmented" };
};
